import { axiosService } from "../axios.service";
import { urls } from "../../constants";

const statisticsService = {
    getPromoCodeUsageByDateRange: ({ startDate, endDate }) =>
        axiosService
            .get(urls.statistics.promoCodeUsage, {
                params: { startDate, endDate }
            })
            .then((value) => value.data),
    getClientRegistrationsByDateRange: ({ startDate, endDate }) =>
        axiosService
            .get(urls.statistics.clientRegistrations, {
                params: { startDate, endDate }
            })
            .then((value) => value.data),
    getDishesCountChart: ({ startDate, endDate, page, limit, search }) =>
        axiosService
            .get(urls.statistics.dishesCountChart, {
                params: {
                    startDate,
                    endDate,
                    page,
                    limit,
                    ...(search !== undefined && search !== null && String(search).trim() !== ""
                        ? { search: String(search).trim() }
                        : {}),
                },
            })
            .then((value) => value.data),
};

export { statisticsService };

